import { IIdmStaffMember } from "../../../entities/idm";

export const emptyStaffMember: IIdmStaffMember = {
    user_id: 0,
    full_name: '',
    email: '',
    phone: '',
    tg: '',
    is_active: false,
    is_archive: false,
    legacy_admin_id: 0,
    legacy_role_id: 0,
    roles: [],
    effective_features: [],
}
